import { render, staticRenderFns } from "./TheProgressBar.vue?vue&type=template&id=3045383b&scoped=true"
import script from "./TheProgressBar.vue?vue&type=script&lang=js"
export * from "./TheProgressBar.vue?vue&type=script&lang=js"
import style0 from "./TheProgressBar.vue?vue&type=style&index=0&id=3045383b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3045383b",
  null
  
)

export default component.exports